export default __webpack_public_path__ + "static/media/piggybank-1.59b61eca.svg";